import { useFormik } from "formik";
import * as Yup from "yup";
import { useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { create_user } from "../../reduxData/auth/authAction";
import PhoneNumber from "../../utils/PhoneNumber";
import Modal from "@mui/joy/Modal";
import ModalDialog from "@mui/joy/ModalDialog";
import DialogTitle from "@mui/joy/DialogTitle";
import Stack from "@mui/joy/Stack";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import Input from "@mui/joy/Input";
import Button from "@mui/joy/Button";
import Grid from "@mui/joy/Grid";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/joy/IconButton";

const AddStoreManager = ({ showModal, setShowMoal, type }) => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.accessToken);
  const { user } = useSelector((state) => state.auth);

  const [showPassword, setNoShowPassword] = useState(false);
  const [showPasswordConfirm, setNoShowPasswordConfirm] = useState(false);
  const [country, setCountry] = useState("AE");

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      password: "",
      confirmPassword: "",
      contact: null,
      role: "store-manager",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required"),
      email: Yup.string().required("Email is required"),
      contact: Yup.number().required("Contact Number is required"),
      password: Yup.string().required("Password is required"),
      confirmPassword: Yup.string()
        .required("Confirm Password is required")
        .oneOf([Yup.ref("password"), null], "Passwords must match"),
    }),
    onSubmit: async (value, { resetForm }) => {
      // if (value.password !== value.confirmPassword) {
      //   toast.error("Password and Confirm Password do not match");
      //   return;
      // }

      console.log("payload", {
        user_name: value?.name,
        email: value?.email,
        password: value?.password,
        role: value?.role,
        phone_no: value?.contact,
        region: country,
      });
      if (type == "Add") {
        await dispatch(
          create_user(
            {
              user_name: value?.name,
              email: value?.email,
              password: value?.password,
              role: value?.role,
              phone_no: value?.contact,
              country_code: country,
            },
            token
          )
        );
      } else {
        const userdata = {
          user_name: value?.name,
          email: value?.email,
          phone_no: value?.contact,
          //   country_code: `+${countrycode}`,
          //   country_code_name: country,
          //   store_name: formData?.store_name,
          //   kyc_no: formData?.kyc_no,
          //   location: formData?.location,
          //   is_deactive: userDetails?.is_deactive,
        };

        const isEdit = await update_user(
          id,
          userdata,
          navigate,
          localStorage.getItem("token"),
          dispatch
        );
      }
      resetForm();
    },
  });

  const handlePhoneChange = useCallback((value) => {
    formik.setFieldValue("contact", value);
  }, []);

  const handlePhoneBlur = useCallback(() => {
    formik.setFieldTouched("contact", true);
  }, []);

  console.log("errores", formik.errors);

  return (
    <Modal open={showModal} onClose={() => setShowMoal(false)}>
      <ModalDialog size="lg" sx={{ width: "800px", maxWidth: "95%" }}>
        {/* Header */}
        <DialogTitle>Add New User</DialogTitle>

        {/* Form */}
        <form onSubmit={formik.handleSubmit}>
          <Stack spacing={2}>
            <Grid container spacing={2}>
              {/* Name */}
              <Grid xs={12} md={6}>
                <FormControl
                  error={formik.touched.name && !!formik.errors.name}
                >
                  <FormLabel>Name</FormLabel>
                  <Input
                    name="name"
                    placeholder="Enter full name"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </FormControl>
                {formik.touched.name && formik.errors.name && (
                  <p className="text-danger m-0 mt-1 required-text">
                    {formik.errors.name}
                  </p>
                )}
              </Grid>

              {/* Email */}
              <Grid xs={12} md={6}>
                <FormControl
                  error={formik.touched.email && !!formik.errors.email}
                >
                  <FormLabel>Email</FormLabel>
                  <Input

                    name="email"
                    placeholder="Enter email"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </FormControl>
                {formik.touched.email && formik.errors.email && (
                  <p className="text-danger m-0 mt-1 required-text">
                    {formik.errors.email}
                  </p>
                )}
              </Grid>

              {/* Password */}
              <Grid xs={12} md={6}>
                <FormControl
                  error={formik.touched.password && !!formik.errors.password}
                >
                  <FormLabel>Password</FormLabel>
                  <Input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    placeholder="Enter password"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    endDecorator={
                      <IconButton
                        variant="plain"
                        size="sm"
                        sx={{ padding: "4px" }}
                        onClick={() => setNoShowPassword((prev) => !prev)}
                      >
                        {showPassword ? (
                          <i class="bi bi-eye-slash fs-6"></i>
                        ) : (
                          <i class="bi bi-eye fs-6"></i>
                        )}
                      </IconButton>
                    }
                  />
                </FormControl>
                {formik.touched.password && formik.errors.password && (
                  <p className="text-danger m-0 mt-1 required-text">
                    {formik.errors.password}
                  </p>
                )}
              </Grid>

              {/* Confirm Password */}
              <Grid xs={12} md={6}>
                <FormControl
                  error={
                    formik.touched.confirmPassword &&
                    !!formik.errors.confirmPassword
                  }
                >
                  <FormLabel>Confirm Password</FormLabel>
                  <Input
                    type={showPasswordConfirm ? "text" : "password"}
                    name="confirmPassword"
                    placeholder="Confirm password"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    endDecorator={
                      <IconButton
                        variant="plain"
                        size="sm"
                        onClick={() =>
                          setNoShowPasswordConfirm((prev) => !prev)
                        }
                      >
                        {showPasswordConfirm ? (
                          <i class="bi bi-eye-slash fs-6"></i>
                        ) : (
                          <i class="bi bi-eye fs-6"></i>
                        )}
                      </IconButton>
                    }
                  />
                </FormControl>
                {formik.touched.confirmPassword &&
                  formik.errors.confirmPassword && (
                    <p className="text-danger m-0 mt-1 required-text">
                      {formik.errors.confirmPassword}
                    </p>
                  )}
              </Grid>

              {/* Contact */}
              <Grid xs={12} md={6}>
                <FormControl
                  error={formik.touched.contact && !!formik.errors.contact}
                >
                  <FormLabel>Contact</FormLabel>

                  <PhoneNumber
                    country={country}
                    setCountry={setCountry}
                    phoneNumber={formik.values.contact}
                    handleChange={handlePhoneChange}
                    onBlur={handlePhoneBlur}
                  />
                </FormControl>
                {formik.touched.contact && formik.errors.contact && (
                  <p className="text-danger m-0 mt-1 required-text">
                    {formik.errors.contact}
                  </p>
                )}
              </Grid>

              {/* Role */}
              <Grid xs={12} md={6}>
                <FormControl>
                  <FormLabel>Role</FormLabel>
                  <Input value="Store Manager" disabled className="" />
                </FormControl>
              </Grid>
            </Grid>

            {/* Footer Buttons */}
            <div className="d-flex justify-content-end gap-2 mt-2">
              <Button
                variant="outlined"
                color="neutral"
                onClick={() => setShowMoal(false)}
              >
                Cancel
              </Button>

              <Button type="submit">Save</Button>
            </div>
          </Stack>
        </form>
      </ModalDialog>
    </Modal>
  );
};

export default AddStoreManager;
